__turbopack_context__.v({
  "actions": "ZamRQW_actions",
  "backdrop": "ZamRQW_backdrop",
  "badge": "ZamRQW_badge",
  "blink": "ZamRQW_blink",
  "button": "ZamRQW_button",
  "button_ghost": "ZamRQW_button_ghost",
  "button_primary": "ZamRQW_button_primary",
  "card": "ZamRQW_card",
  "description": "ZamRQW_description",
  "joke": "ZamRQW_joke",
  "loading_dots": "ZamRQW_loading_dots",
  "loading_row": "ZamRQW_loading_row",
  "loading_text": "ZamRQW_loading_text",
  "meme_box": "ZamRQW_meme_box",
  "meme_face": "ZamRQW_meme_face",
  "meme_text": "ZamRQW_meme_text",
  "meme_title": "ZamRQW_meme_title",
  "meta": "ZamRQW_meta",
  "page": "ZamRQW_page",
  "page_fullscreen": "ZamRQW_page_fullscreen",
  "spin": "ZamRQW_spin",
  "spinner": "ZamRQW_spinner",
  "title": "ZamRQW_title",
});
